import { render } from "./GoogleSignIn.vue?vue&type=template&id=50a01f88&ts=true"
import script from "./GoogleSignIn.vue?vue&type=script&lang=ts"
export * from "./GoogleSignIn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__